import { render, staticRenderFns } from "./MinimalSpinner.vue?vue&type=template&id=2405e0fd&scoped=true&"
import script from "./MinimalSpinner.vue?vue&type=script&lang=js&"
export * from "./MinimalSpinner.vue?vue&type=script&lang=js&"
import style0 from "./MinimalSpinner.vue?vue&type=style&index=0&id=2405e0fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2405e0fd",
  null
  
)

export default component.exports